import React from "react";
import { Helmet } from "react-helmet-async";
import WebDesignBanner from "./WebAppBanner";
import WebDesignProfileContent from "./WebAppProfileContent";
import WebDesignServices from "./WebAppServices";
import "../Services.css";
import WebDesignDev from "./WebAppDev";
import { CallToAction } from "../../Template/CTA/CallToAction";
import { TechnologyStack } from "./TechnologyStack";

export default function WebDesign() {
  return (
    <>
      <Helmet>
        <title>Web Application Development</title>
        <meta
          name="description"
          content="creative and technological solution agency"
        />
      </Helmet>
      <WebDesignBanner />
      <WebDesignProfileContent />
      <WebDesignServices />
      <WebDesignDev />
      <TechnologyStack />
      <CallToAction />
    </>
  );
}
